import events from "/events";
import cookie from "/utils/cookie";

const pageExceptionClasses = [
  ".landing_pages__get_more"
];

const openWdyhauBasedOnUrlParam = () => {
  const urlParams = new URL(window.location.href).searchParams;
  if (urlParams.get("wdyhau")) {
    setTimeout(function() {
      events.emit("modal:wdyhau-survey:open");
    }, 1000);
  }
};

const registerWdyhauEventListeners = () => {
  document.addEventListener("click", e => {
    const target = e.target.closest("[data-wdyhau-option]");

    if (!target) {
      return;
    }
    const option = target.dataset.wdyhauOption;
    events.track("modal-20180620-wdhyau_survey", "2-select", option);
    events.emit("modal:wdyhau-survey:step:next");
  });
};

export const setWdyhauTrafficCookie = () => {
  const urlParams = new URL(window.location.href).searchParams;
  const isExcludedPage = document.querySelector(pageExceptionClasses.join(",")) !== null;

  if ((urlParams.get("utm_medium") === "paid") || isExcludedPage) {
    const validity = 1; // 24 hours
    cookie("modal-wdyhau-survey", "1", validity);
  }
};

export const wdyhauEventHandlers = {
  "setup:ready": () => {
    registerWdyhauEventListeners();
    openWdyhauBasedOnUrlParam();
  }
};
